export default __webpack_public_path__ + "static/media/badge-google-play.b8c5ac16.svg";